import { useState } from 'react';
import { useUrlState } from '#client/hooks/useUrlState';
import { JUST_REGISTERED } from '#client/lib/routes';

export interface SlipPrompt {
  /** Arrived straight from the registration form. */
  isNewlyRegistered: boolean;
  isSlipOpen: boolean;
  openSlip: () => void;
  closeSlip: () => void;
  dismissPrompt: () => void;
}

/**
 * The slip dialog, and the one-time prompt to print it after registering.
 *
 * `?registered=1` is set by the registration form's redirect. It opens the
 * print dialog once and is then cleared from the URL, so a refresh or a back
 * navigation does not reopen it.
 */
export function useSlipPrompt(): SlipPrompt {
  const { params, setParam } = useUrlState();
  const isNewlyRegistered = params.get(JUST_REGISTERED) === '1';
  const [isSlipOpen, setIsSlipOpen] = useState(isNewlyRegistered);

  const dismissPrompt = () => setParam(JUST_REGISTERED, undefined, { replace: true });

  return {
    isNewlyRegistered,
    isSlipOpen,
    openSlip: () => setIsSlipOpen(true),
    closeSlip: () => {
      setIsSlipOpen(false);
      dismissPrompt();
    },
    dismissPrompt,
  };
}
